import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[matDateMask]'
})
export class MatDateMaskDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const input = this.el.nativeElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length > 5) {
      value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value;
  }
}